<template>
  <div class="newsJump">
    <img v-if="checkDevice=='pc'" class="mens" src="../assets/images/news/men.png" alt />
    <div v-if="checkDevice=='pc'" class="box"></div>

    <div class="newsJump_center">
      <div class="news_type_box">
        <div class="news_type" v-for="(item, index) in newsType" :key="index" @click="newsChange(item.id)">
          <img
            :src="item.id==category?require('../assets/images/news/news_active.png'):require('../assets/images/news/news_active_off.png')"
            alt="">
          <span>
            {{item.name}}
          </span>
        </div>
      </div>
      <div class="catalogueBox">
        <div class="catalogue" v-if="checkDevice=='pc'">
          <ul>
            <li v-for="(itemCon, index) in LatestNews.slice(0, 8)" :key="index" @click="changeDetail(itemCon.id)">
              <!-- <a @click="change(`/newsjumps/${itemCon.id}`)"></a> -->
              <div class="catalogue-title">{{ itemCon.title }}</div>
              <p>
                {{ itemCon.summary }}
              </p>
              <div class="catalogue-time">{{ shijianfilter(itemCon.publishTime) }}</div>
            </li>
          </ul>
        </div>
        <div class="catalogue" v-if="checkDevice=='pc'">
          <ul>
            <li v-for="(itemCon, index) in LatestNews.slice(8, 16)" :key="index" @click="changeDetail(itemCon.id)">
              <!-- <a @click="change(`/newsjumps/${itemCon.id}`)"></a> -->
              <div class="catalogue-title">{{ itemCon.title }}</div>
              <p>
                {{ itemCon.summary }}
              </p>
              <div class="catalogue-time">{{ shijianfilter(itemCon.publishTime) }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="catalogue" v-if="checkDevice=='mobile'">
        <ul>
          <li v-for="(itemCon, index) in LatestNews" :key="index" @click="changeDetail(itemCon.id)">
            <!-- <a @click="change(`/newsjumps/${itemCon.id}`)"></a> -->
            <div class="catalogue-title">{{ itemCon.title }}</div>
            <p>
              {{ itemCon.summary }}
            </p>
            <div class="catalogue-time">{{ shijianfilter(itemCon.publishTime) }}</div>
          </li>
        </ul>
        <div class="fanye">
          <page ref="fanye" v-if="checkDevice=='mobile'" :page_total="total" :page_index="1" :page_size="limit"
            @change="changePage"></page>
        </div>
      </div>
      <div class="fanye">
        <page ref="fanye" v-if="checkDevice=='pc'" :page_total="total" :page_index="1" :page_size="limit"
          @change="changePage"></page>
      </div>
    </div>
  </div>
</template>

<script>
import page from "@/components/fanye";
export default {
  name: "newsJump",
  components: {
    page,
  },
  data: () => ({
    category: 0, //类别
    limit: 16, //每页数量
    page: 1, //页数
    LatestNews: [], //
    total: 0,
    content: "", //详情信息
    newsType:[
      {name:'すべて',id:0},
      {name:'メンテナンス',id:3},
      {name:'お知らせ',id:2},
      {name:'イベント',id:1},
    ]
  }),
  created() {
    this.checkDevice=='mobile'?this.limit=8:this.limit=16
    this.DefauLtlist();
    // this.getNewsDetail();
  },
  mounted() {},
  watch: {},
  computed: {
    checkDevice() {
      return this.$utils.checkDevice();
    },
    params() {
      return (
        "typeId=" +
        this.category +
        "&pageNum=" +
        this.limit +
        "&pageIndex=" +
        this.page
      );
    },
  },
  methods: {
    change(path) {
      this.$router.push(path);
    },
    DefauLtlist() {
      this.axios
        .get(`${process.env.VUE_APP_NEWS_HOST}/api/news/list?` + this.params)
        .then((v) => {
          if (v.data.meta.ok) {
            this.LatestNews = v.data.data.rows;
            this.total = v.data.data.count;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getNewsDetail() {
    //   this.axios
    //     .get(
    //       "https://www.bluearchive.jp:10026/news/detail?id=" + this.$route.params.id
    //     )
    //     .then((v) => {
    //       this.content = v.data.data.items[0].content[0].value;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    changePage(e) {
      this.page = e;
      this.DefauLtlist();
    },
    changeDetail(id) {
      // this.$route.params.id = id;
      // window.history.pushState(id, "", "/#/news/newsJump/" + id);
      // this.getNewsDetail();
      if (this.checkDevice=='pc') {
        const routeUrl = this.$router.resolve({
          path: `/news/newsJump/${id}`,
          // query: {id:96}
        });
        window.open(routeUrl .href, '_blank');
        return
      }
      this.$router.push(`/news/newsJump/${id}`);
    },
    //格式化時間
    shijianfilter(time) {
      var dt = new Date(time);
      var y = dt.getFullYear();
      var m = (dt.getMonth()+1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      var hh = dt.getHours().toString().padStart(2, "0");
      var mm = dt.getMinutes().toString().padStart(2, "0");
      var ss = dt.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}`;
      // }
    },
    newsChange (id) {
      this.page = 1
      this.$refs.fanye.page_index_inside = 1
      this.category = id
      this.DefauLtlist()
    }
  },
};
</script>

<style lang="scss" scoped>
.newsJump {
  position: relative;
  overflow: hidden;
  width: 100%;
  font-size: pxTorem(50px);
  height: pxTorem(1080px);
  background: url(../assets/images/home/news_bk.png);
  background-size: 100% 100%;
  letter-spacing: pxTorem(1px);
  .mens {
    left: pxTorem(-66px);
    width: pxTorem(636px);
    top: pxTorem(58px);
    position: absolute;
  }
  .box {
    width: 100px;
    height: pxTorem(96px);
  }
  .newsJump_center {
    display: flex;
    height: pxTorem(958px);
    width: pxTorem(1344px);
    background: url(../assets/images/news/newsbg2.png);
    background-size: 100% 100%;
    margin-left: pxTorem(430px);
    box-sizing: border-box;
    padding: pxTorem(48px) pxTorem(44px) 0 pxTorem(52px);
    flex-direction: column;
    .news_type_box {
      position: relative;
      display: flex;
      align-items: center;
      font-size: pxTorem(20px);
      color: #fff;
      .news_type {
        margin-right: pxTorem(18px);
        cursor: pointer;
        display: flex;
        align-items: center;
        width: auto;
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 400;
        img {
          width: pxTorem(20px);
          margin-right: pxTorem(5px);
        }
      }
    }
    .catalogueBox {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-top: pxTorem(30px);
    }
    .catalogue {
      width: pxTorem(585px);
      margin-right: pxTorem(14px);
      ul {
        li {
          cursor: pointer;
          width: 100%;
          height: pxTorem(70px);
          border-bottom: pxTorem(2px) solid #909090;
          
          box-sizing: border-box;
          position: relative;
          a {
            display: none;
          }
          .catalogue-title {
            width: pxTorem(92px);
            background: #56dbfb;
            height: pxTorem(24px);
            line-height: pxTorem(24px);
            font-size: pxTorem(12px);
            text-align: center;
            color: white;
            float: left;
            border-radius: pxTorem(5px);
            margin-top: pxTorem(22px);
            font-family: "Noto Sans JP", sans-serif;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          p {
            width: pxTorem(435px);
            float: right;
            font-size: pxTorem(16px);
            font-family: "Noto Sans JP", sans-serif;
            font-weight: 500;
            color: white;
            line-height: pxTorem(24px);
            word-wrap: break-word;
            word-break: normal;
            margin-top: pxTorem(13px);
          }
          .catalogue-time {
            position: absolute;
            right: pxTorem(8px);
            bottom: 0;
            font-size: pxTorem(11px);
            font-family: "Noto Sans JP", sans-serif;
            font-weight: 400;
            color: white;
          }
        }
      }
    }
    .fanye {
      margin-top: pxTorem(50px);
    }
    // .content {
    //   height: 100px;
    //   width: pxTorem(460px);

    //   height: pxTorem(750px);
    //   position: relative;
    //   overflow: hidden;
    //   .content_cen {
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     right: pxTorem(-24px);
    //     bottom: 0;
    //     overflow-x: hidden;
    //     overflow-y: scroll;
    //     padding-right: pxTorem(10px);
    //     & ::v-deep .wscnph {
    //       width: 100%;
    //     }
    //     & ::v-deep p {
    //       word-wrap: break-word;
    //       word-break: normal;
    //       font-size: pxTorem(16px);
    //       line-height: pxTorem(24px);
    //     }
    //   }
    // }
  }
}
@media screen and (max-width: 1600px) {
  .newsJump {
    .newsJump_center {
      .catalogue {
        ul {
          li {
            .catalogue-title {
              width: pxTorem(130px);
              font-size: pxTorem(12px);
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .newsJump {
    background: url(../assets/images/home/newJbg.png);
    background-size: 100% 100%;
    width: 100%;
    overflow: hidden;
    height: MpxTorem(1920px);
    .newsJump_center {
      display: flex;
      height: pxTorem(958px);
      width: 100%;
      background: none;
      background-size: 100% 100%;
      margin-left: pxTorem(0px);
      box-sizing: border-box;
      padding: MpxTorem(210px) MpxTorem(54px) 0;
      .news_type_box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: MpxTorem(30px);
        color: #000;
        .news_type {
          margin-right: MpxTorem(18px);
          cursor: pointer;
          display: flex;
          align-items: center;
          width: auto;
          img {
            width: MpxTorem(50px);
            margin-right: MpxTorem(5px);
          }
        }
      }
      .catalogue {
        width: 100%;
        margin: 0;
        margin-top: MpxTorem(48px);
        ul {
          li {
            width: 100%;
            height: MpxTorem(128px);
            border-bottom: MpxTorem(3px) solid #909090;
            // padding-top: MpxTorem(47px);
            box-sizing: border-box;
            position: relative;
            padding-right: MpxTorem(10px);
            a {
              // background: violet;
              position: absolute;
              display: block;
              height: MpxTorem(128px);
              width: 100%;
              top: 0;
            }
            .catalogue-title {
              width: MpxTorem(165px);
              background: #56dbfb;
              height: MpxTorem(42px);
              line-height: MpxTorem(42px);
              font-size: MpxTorem(18px);
              text-align: center;
              color: white;
              float: left;
              margin-top: MpxTorem(47px);
            }
            p {
              width: MpxTorem(756px);
              float: right;
              font-size: MpxTorem(21px);
              color: #000;
              line-height: MpxTorem(29px);
              word-wrap: break-word;
              word-break: normal;
              margin-top: MpxTorem(37px);
            }
            .catalogue-time {
              position: absolute;
              right: MpxTorem(10px);
              bottom: 0;
              font-size: MpxTorem(17px);
              color: #000;
            }
          }
        }
      }
      // .content {
      //   display: none;
      //   height: 100px;
      //   width: pxTorem(460px);
      //   height: pxTorem(624px);
      //   position: relative;
      //   overflow: hidden;
      //   .content_cen {
      //     position: absolute;
      //     left: 0;
      //     top: 0;
      //     right: pxTorem(-24px);
      //     bottom: 0;
      //     overflow-x: hidden;
      //     overflow-y: scroll;
      //     img {
      //       max-width: pxTorem(406px);
      //     }
      //     p {
      //       word-wrap: break-word;
      //       word-break: normal;
      //       font-size: pxTorem(20px);
      //       line-height: pxTorem(24px);
      //     }
      //   }
      // }
    }
  }
}
</style>
